const LOCAL_USER_EMAIL_DOMAIN = "local.user";

export const localUsernameToEmail = (value: string): string => {
  const identifier = value.trim().toLowerCase();
  return identifier.includes("@")
    ? identifier
    : `${identifier}@${LOCAL_USER_EMAIL_DOMAIN}`;
};

export const displayLoginIdentifier = (email: string): string => {
  const suffix = `@${LOCAL_USER_EMAIL_DOMAIN}`;
  return email.endsWith(suffix) ? email.slice(0, -suffix.length) : email;
};

export const isLocalLoginIdentifier = (email: string): boolean =>
  email.endsWith(`@${LOCAL_USER_EMAIL_DOMAIN}`);
